import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';

const FullLayout: React.FC = () => {
  return (
    <Suspense fallback={null}>
      <Outlet />
    </Suspense>
  );
};

export default FullLayout;
